























































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import InputField from '@/components/common/inputs/InputField.vue';
import DatePicker from '@/components/common/inputs/DatePicker.vue';
import MaskableInput from '@/components/common/inputs/MaskableInput.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import AssociatedProcesses from '@/components/common/inputs/AssociatedProcesses.vue';
import MappedSelectionField from '@/components/common/inputs/MappedSelectionField.vue';
import SmallSearchResult from '@/components/search/SmallSearchResult.vue';
import DomainsField from '@/components/common/inputs/DomainsField.vue';
import TextArea from '@/components/common/inputs/TextArea.vue';
import Well from '@/components/common/Well.vue';
import WellItem from '@/components/common/WellItem.vue';
import FormSection from '@/components/details/FormSection.vue';
import WarningIcon from '@/components/icons/WarningIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import { User } from '@/store/modules/auth';
import { StatusKeys, StatusLabels } from '@/models/status';
import { VisibilityKeys, VisibilityLabels, VisibilityOrder, Visibility } from '@/models/visibility';
import { ProcessReport } from '@/store/modules/processInterfaces';
import { Kle, OrgUnit, UserSearchRequest } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import { TypeLabels, TypeKeys } from '@/models/types';
import { Domain } from '@/models/domain';
import { Phase, PhaseKeys } from '@/models/phase';
import MunicipalityLogo from '@/components/common/MunicipalityLogo.vue';
import StarIcon from '@/components/icons/StarIcon.vue';
import { AuthModule } from '@/store/modules/auth';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import { ErrorModule } from '@/store/modules/error';
import { OrganisationModule } from '@/store/modules/organisation';

@Component({
  components: {
    StarIcon,
    MunicipalityLogo,
    InputField,
    DomainsField,
    SelectionField,
    SmallSearchResult,
    AssociatedProcesses,
    MappedSelectionField,
    DatePicker,
    TextArea,
    Well,
    FormSection,
    MaskableInput,
    WellItem,
    WarningIcon,
    DeleteIcon
  }
})
export default class UmbrellaForm extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;

  TypeLabels = TypeLabels;
  VisibilityLabels = VisibilityLabels;
  VisibilityKeys = VisibilityKeys;

  get state() {
    return ProcessModule;
  }

  get common() {
    return CommonModule;
  }

  get logo() {
    if (this.state.base64Logo != null) {
      return this.state.base64Logo;
    } else {
      return `/logos/${ProcessModule.cvr}.png`;
    }
  }

  get canEditOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return true;
      }
      return false;
    } else {
      return ProcessModule.canEditOtherContact;
    }
  }

  get calculatedOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return ProcessModule.otherContactEmail;
      } else {
        return OrganisationModule.autoOtherContactEmail;
      }
    } else {
      return ProcessModule.otherContactEmail;
    }
  }

  assign(state: Partial<ProcessState>) {
    ProcessModule.assign(state);
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.generalInformation, name);
  }

  search(name: string) {
    const request: UserSearchRequest = { name: `${name}`, cvr: '' };
    if (AuthModule.user) {
      request.cvr = AuthModule.user.cvr;
      CommonModule.searchUsers(request);
    } else {
      CommonModule.searchUsers(request);
    }
  }

  isLessVisible(visiblity: Visibility) {
    return !!ProcessModule.visibility
      ? VisibilityOrder.indexOf(visiblity) < VisibilityOrder.indexOf(ProcessModule.visibility)
      : false;
  }

  setKla(kla: string) {
    // Inserts periodes for every 2 characters, to match format: ##.##.##.##.##
    ProcessModule.update({ kla: kla.replace(/(\d{2})(?=\d)/g, '$1.') });
  }

  setKle(kle: Kle) {
    if (!kle) {
      ProcessModule.update({ kle, form: null });
    } else {
      ProcessModule.update({ kle });
    }
    CommonModule.loadFormsByKle(kle);
  }

  setBookmark(bookmarked: boolean) {
    ProcessModule.setBookmark(bookmarked);
  }

  addProcess(process: ProcessReport) {
    if (ProcessModule.children && !ProcessModule.children?.find((child: ProcessReport) => child.id === process.id)) {
      ProcessModule.assign({ children: [...ProcessModule.children, process] });
    }
  }

  removeProcess(process: ProcessReport) {
    ProcessModule.assign({
      children: ProcessModule.children?.filter((child: ProcessReport) => child.id !== process.id)
    });
  }
}
